import React from 'react'
import PropTypes from 'prop-types'

function HeaderItem({ name = '', Icon }) {
    return (
        <div className='flex items-center gap-2 text-base md:text-lg font-semibold text-gray-300 hover:text-teal-300 transition-colors duration-200 cursor-pointer group'>
            <Icon 
                className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" 
                aria-hidden="true"
            />
            {name && (
                <span className='select-none group-hover:underline underline-offset-4 decoration-2 decoration-teal-300/50'>
                    {name}
                </span>
            )}
        </div>
    )
}

HeaderItem.propTypes = {
    name: PropTypes.string,
    Icon: PropTypes.elementType.isRequired,
}

export default HeaderItem